import { useTheme } from "@emotion/react"

import { useUrlParams } from "@l2r-front/l2r-utils"

import { useMediaQuery } from "./useMediaQuery"


export function useIsMobileDevice() {
    const theme = useTheme()
    const { getParam } = useUrlParams()
    const forcedDevice = getParam("device")

    const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"))
    const isMobileDevice = !isLargeScreen

    return (isMobileDevice && forcedDevice !== "desktop") || forcedDevice === "mobile"
}

export function useIsMobileOrTabletDevice() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera

    const isTablet = /iPad|Android(?!.*Mobile)|Tablet|PlayBook|Silk/i.test(userAgent)
    const isMobile = /Mobi|iPhone|iPod|Android.*Mobile|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(userAgent)

    return isMobile || isTablet || navigator.maxTouchPoints > 1
}